<nz-tabset [nzSelectedIndex]="selectedIndex" (nzSelectedIndexChange)="onTabChange($event)">
  <nz-tab
    nzTitle="Build Model"
    *ngIf="appService.isEngagementActive && authService.hasEntitlements(viewMlRelatedTabs)"
  ></nz-tab>
  <nz-tab nzTitle="Model History" *ngIf="authService.hasEntitlements(viewMlRelatedTabs)"></nz-tab>
</nz-tabset>

<div class="tab-content">
  <router-outlet></router-outlet>
</div>
